import axios from '@axios'

export default {
  getContentKeywords(page, field) {
    return axios.post(`contentkeywords/list?page=${page}`, field)
  },
}
